// extracted by mini-css-extract-plugin
export default {"meudado":"meusdados_meudado__CMKrd"};